import { getApiClient } from 'adapter/out/client/apiClient';
import { ReportInstance } from 'domain/entity/reportInstance';
import CreateReportInstanceCriteria from 'use-case/reportInstance/create/createReportInstanceCritera';
import { DashboardFrame } from 'domain/entity/dashboard';

const createReportInstanceApiClient = getApiClient(
    () => `dashboards/reports`,
    ReportInstance,
    (clientCriteria: CreateReportInstanceCriteria) => ({
        method: 'POST',
        body: JSON.stringify(parseCreateReportInstanceCriteria(clientCriteria)),
        headers: { 'Content-Type': 'application/json' },
    })
);

const parseCreateReportInstanceCriteria = (criteria: CreateReportInstanceCriteria) => ({
    name: criteria.name,
    template_dashboard_id: criteria.templateId,
    context: {
        period: criteria.period,
        location_id: criteria.location,
        language: criteria.language,
        logo_image_url: criteria.logo,
        location_tags: criteria.locationTags.join(','),
    },
    visibility: {
        scope: criteria.scope,
        user_ids: criteria.userIds,
    },
    ...(criteria.frame ? { template_dashboard_frame: asReportInstanceFrameJson(criteria.frame) } : {}),
});

const asReportInstanceFrameJson = (frame: DashboardFrame) => ({
    header: {
        logo: frame.header.logo,
        template_name: frame.header.templateName,
        period: frame.header.period,
        location: frame.header.location,
    },
    footer: {
        generation_date: frame.footer.generationDate,
        page_number: frame.footer.pageNumber,
    },
});

export default createReportInstanceApiClient;
